class SiteStatementForeach
    extends QueryElement<HTMLElement> {
    
    constructor(card: ISiteCard, element: HTMLElement) {
        super(element, false);

        let path = this.getAttr('data-path');
        let name = this.getAttr('data-name');
        let global = this.getAttr('data-global');
        let value = card.Model.get((path && SiteModel.split(path)) || []) as any[];

        if (value == null)
            return;

        // Get inserting parent:
        let parent = this.parent();
        if (parent == null)
            throw "No parent found.";
        
        let propertiesToReplace = ["data-path", "data-config"];

        // Duplicate it:
        for (let x of Object.keys(value)) {
            let toReplaceString = global ? `[${name}]` : `${path}[${name}]`;
            let toReplaceStringBy = global ? `[${x}]` : `${path}[${x}]`;

            let newContent = element.cloneNode(true) as HTMLElement;
            
            for (var propertyToReplace of propertiesToReplace)
            {
                let selector = global ? `[${propertyToReplace}*="${toReplaceString}"]` : `[${propertyToReplace}^="${toReplaceString}"]`;
                let toReplaceElements = newContent.querySelectorAll(selector);
                for (let y = 0; y < toReplaceElements.length; y++)
                {
                    let toReplaceElement = toReplaceElements[y];
                    let newValue = (toReplaceElement.getAttribute(propertyToReplace) || "")
                        .replace(toReplaceString, toReplaceStringBy);

                    toReplaceElement.setAttribute(propertyToReplace, newValue);
                }
            }

            let innerForeach = newContent.querySelectorAll("div[data-type='foreach']");
            for (let y = 0; y < innerForeach.length; y++)
            {
                new SiteStatementForeach(card, innerForeach[y] as HTMLElement);
            }
            
            while(newContent.children.length != 0) {
                parent.insertBefore(
                    new QueryElement(newContent.children[0], false),
                    this);
            }
        }

        element.remove();
    }
}